<template>
  <Card title="Egyéb kérdőívek">
    <template v-slot:body>
      <div v-for="(survey, index) in $store.state.inspection.selected.details.other_surveys"
           :key="index">
        <div>{{ survey.name }}</div>
        <ul v-if="survey.commissions && survey.commissions.length > 0"
            class="mt-1 mb-2">
          <li v-for="(commission, commissionIndex) in survey.commissions"
              :key="commissionIndex">
            {{ commission.name }} ({{ commission.year }})
          </li>
        </ul>
      </div>
      <strong v-if="$store.state.inspection.selected.details.other_surveys.length === 0">
        Nincsenek kérdőívek
      </strong>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Cards/Common/Card'

export default {
  name: 'QuestionnairesCard',
  components: { Card },
}
</script>

<style scoped>

</style>
